import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import style from './gl-container.css';
import GLApp from "../../gl/GLApp";
import arrow from '../../assets/arrow.svg';
import cross from '../../assets/cross.svg';
import 'fonts.css';

const GLContainer = () => {

    const ref = useRef();
    const glApp = useRef();
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [inited, setInited] = useState(false);
    const [isZoomed, setIsZoomed] = useState(false);

    useEffect(() => {
        if (!inited) {
            glApp.current = new GLApp(ref.current);
            glApp.current.onZoomOut = () => {
                setIsZoomed(false);
            }
            glApp.current.onZoomIn = () => {
                setIsZoomed(true);
            }
            glApp.current.onLoadingProgress = (total) => {
                setLoadingProgress(total);
            }
            setInited(true);
        }
    }, [ref.current]);

    return (

      <>
          <div style={{ width: '100%', height: '100%', position: 'relative' }}>
              {
                  isZoomed &&
                  <div style={{ boxSizing: 'border-box', padding: '30px', position: 'absolute', width: '100%', height: '100%', display: 'flex', flexDirection: 'column', pointerEvents: 'none' }}>
                      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', pointerEvents: 'all' }}>
                          <img style={{ cursor: 'pointer' }} onClick={() => glApp.current.zoomOut()} src={cross} alt=""/>
                      </div>
                      <div style={{ flex: '1' }} />
                      <div style={{ display: 'flex' }}>
                          <div style={{ pointerEvents: 'all', marginRight: '16px' }}><img style={{ cursor: 'pointer' }} onClick={() => glApp.current.prev()} src={arrow} alt=""/></div>
                          <div style={{ pointerEvents: 'all' }}><img style={{ cursor: 'pointer' }} onClick={() => glApp.current.next()} style={{ transform: 'scaleX(-1)'}} src={arrow} alt=""/></div>
                      </div>
                  </div>
              }

              {
                  loadingProgress !== 1 &&
                  <div style={{ flexDirection: 'column', textAlign: 'center', background: '#A1A1A1', fontFamily: 'Cabin', boxSizing: 'border-box', padding: '30px', position: 'absolute', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
                      <h1 style={{ color: 'white', fontSize: '52px' }}>Welcome to Altra</h1>
                      <br />
                      <h2 style={{ color: 'white', fontSize: '28px', }}>Loading {Math.floor(loadingProgress * 100)}%</h2>
                  </div>
              }
              <div ref={ref} className={style['gl-container']} />
          </div>
      </>
    );

}

GLContainer.propTypes = {
  title: PropTypes.string,
};

export default GLContainer;
